const styleTables = () => {
  const tables = document.querySelectorAll('.element--elementcontent table');

  tables.forEach((table) => {
    // create wrapper container
    const wrapper = document.createElement('div');

    // add class to wrapper container
    wrapper.classList.add('table-wrapper');

    // insert wrapper before el in the DOM tree
    table.parentNode.insertBefore(wrapper, table);

    // move el into wrapper
    wrapper.appendChild(table);
  });
};

window.addEventListener(
  'load',
  () => {
    window.removeEventListener('load', styleTables, false);
    styleTables();
  },
  false
);
